import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { IFoodCategory } from "../models/IFoodCategory";
import { getFoodCategoryList } from "../services/foodCategory";
import { useLanguage } from "../context/LanguageContext";
import "../styles/style.css";

/**
 * Ana sayfadaki yuvarlak resimli kategori şeridi.
 *
 * Kategoriye tıklayınca arama sayfasına kategori filtresiyle gidilir; orada
 * filtre kaldırılabilir bir etiket olarak görünür. Uç anonim olduğu için
 * misafir kullanıcıda da çalışır.
 */
function FoodCategoryStrip() {
  const [categories, setCategories] = useState<IFoodCategory[]>([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();
  const { t, lang } = useLanguage();

  useEffect(() => {
    getFoodCategoryList()
      .then((res) => setCategories(res.data))
      .catch(() => setCategories([]))
      .finally(() => setLoading(false));
  }, []);

  const nameOf = (c: IFoodCategory) =>
    lang === "en" ? c.foodCategoryNameEn : c.foodCategoryNameTr;

  if (loading) {
    return (
      <div className="food-category-strip" aria-hidden="true">
        {Array.from({ length: 6 }).map((_, i) => (
          <div key={i} className="food-category-strip__item">
            <div className="skeleton food-category-strip__circle" />
            <div className="skeleton" style={{ height: "10px", width: "70%", borderRadius: "4px" }} />
          </div>
        ))}
      </div>
    );
  }

  // Kategori yoksa başlık ve boş şerit göstermek yerine hiç render etme.
  if (categories.length === 0) return null;

  return (
    <nav className="food-category-strip" aria-label={t("categories.title")}>
      {categories.map((c) => (
        <button
          key={c.id}
          type="button"
          className="food-category-strip__item"
          onClick={() => navigate(`/restaurants?categoryId=${c.id}`)}
        >
          <span className="food-category-strip__circle">
            {c.foodCategoryImageUrl ? (
              <img src={c.foodCategoryImageUrl} alt="" loading="lazy" />
            ) : (
              <i className="bi bi-egg-fried" />
            )}
          </span>
          <span className="food-category-strip__label">{nameOf(c)}</span>
        </button>
      ))}
    </nav>
  );
}

export default FoodCategoryStrip;
